class VideoItemController {
  constructor($scope) {
    'ngInject';
    // automatically play videos when loaded
    $scope.$on('youtube.player.ready', ($event, player) => {
      console.log('Play loaded video');
      player.playVideo();
    });
  }
}

export default VideoItemController;



// WEBPACK FOOTER //
// ./client/app/components/apps/videoItem/videoItem.controller.js